<!-- static content data from lang: my_request -->
<template>
  <div>
    <div class="h-100" v-loading="loading">
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.headerTitle}}</h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div>
            <div class="col-12 text-center text-lg-left">
              <template v-for="(message) in alertMessages">
                <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <template v-for="(message) in successMessages">
                <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <div class="row">
                <div
                  class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    autocomplete="off"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>

                  <div>
                    <base-input
                      v-model="searchQuery"
                      autocomplete="off"
                      prepend-icon="fas fa-search"
                      :placeholder="lang.label.search"
                    ></base-input>
                  </div>
                </div>
              </div>
            </div>
          <div class="col-12">
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
              border
            >
              <el-table-column min-width="200px" label="Company Name" prop="CompanyName" sortable></el-table-column>
              <el-table-column min-width="150px" label="Site Name" prop="SiteName" sortable></el-table-column>
              <!-- <el-table-column min-width="150px" label="Access Date" prop="accessDate" sortable></el-table-column> -->
               <el-table-column min-width="150px" label="Access Date"  sortable>
                <!-- <template> -->
                <div class="d-flex"  slot-scope="scope" ><span>{{scope.row.AccessRequestDateFrom}}</span> <span> &nbsp; - &nbsp;</span>
                <span>  {{scope.row.AccessRequestDateTo}} </span>
                   </div>
                    <!-- </template> -->
              </el-table-column>
              <el-table-column min-width="150px" label="Host User Name" prop="HostUser" sortable></el-table-column>
              <!-- <el-table-column label="Status" min-width="170px" prop="status" sortable>
                <template v-slot="{row}">
                  <badge class="badge-dot mr-4" type>
                    <i :class="`bg-${row.statusType}`"></i>
                    <span class="status">{{row.status}}</span>
                  </badge>
                </template>
              </el-table-column> -->
              <el-table-column width="150px" align="right" label="Status" prop="Status">
                <div class="d-flex" slot-scope="scope">
                  <badge class="badge-dot mr-4" type>
                    <i :class="scope.row.Status.includes('Granted')? `bg-success`:(scope.row.Status.includes('Declined')?`bg-danger`: `bg-warning`)"></i>
                    <span class="status">{{scope.row.Status}}</span>
                  </badge>
                </div>
                <!--<div class="d-flex" slot-scope="scope">
                  <span>  {{scope.row.Status}} </span>
                </div>-->
              </el-table-column>
              <el-table-column width="100px" align="right" label="Actions" prop="ID">
                <div class="d-flex" slot-scope="scope" >
                  <el-tooltip :content="lang.label.tooltips.view" placement="bottom">
                    <base-button class="btn-link" type="info" size="sm" icon @click="view(scope.row.ID)">
                      <i class="text-white fas fa-eye"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          </div>
          <div
            class="col-12 mt-3 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{lang.label.showPagination.showing}} {{ from + 1 }} {{lang.label.showPagination.to}} {{ to }} {{lang.label.showPagination.of}} {{ total }} {{lang.label.showPagination.entries}}
                <span
                  v-if="selectedRows.length"
                >&nbsp; &nbsp; {{selectedRows.length}} {{lang.label.showPagination.rowsSelected}}</span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Alert from "@/components/BaseAlert.vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import {mapGetters} from "vuex";
// import users from "../../Tables/users2";
import { Modal } from "@/components";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    Alert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker
  },
  data() {
    return {
      alertType: 'danger',
      successType: 'success',
      alertMessages: [],
      successMessages: [],
      lang: this.$lang.my_request,
      loading:true,
      propsToSearch: ["ID","CompanyName", "SiteName", "HostUser","AccessRequestDateFrom","AccessRequestDateTo", "status"],
      selectedindex: 0,
      tableColumns: [
        {
          type: "selection"
        }
      ],
      tableData: [],
      selectedRows: [],
    };
  },
  computed:{
        ...mapGetters({
            login: "login",
            disqualified: "disqualified",
        })
  },
  mounted(){
      let self = this;
      if(this.disqualified){
          if(this.disqualified && this.disqualified.includes('Based')) {
              self.alertMessages.push(this.disqualified);
          }else{
              self.successMessages.push(this.disqualified);
          }
          setTimeout(function () {
              self.alertMessages = [];
              self.successMessages = [];
              self.$store.commit('setDisqualified','');
          },5000)
      }
    this.visitorsList();
  },
  methods: {
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    view(ID) {
       this.$router.push({ name: "myRequest" , params:{id:ID} });
    },
    onSubmit(){
    },
     visitorsList(){
      this.$store.dispatch('visitorFormsList')
                    .then(response => {
                        this.tableData = response;
                        this.loading = false;
                    })
                    .catch(error => {

                    })
                    .finally(() => this.loading = false);
    },
  }
};
</script>

<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
</style>
